<script>
  import { page, Link } from '@inertiajs/svelte'

  export let href
  export let props = {}

  function isCurrent() {
    const currentUrl = new URL($page.url, window.location.origin)
    const targetUrl = new URL(href, window.location.origin)
    let current = currentUrl.pathname + currentUrl.search === targetUrl.pathname + targetUrl.search
    //console.log(currentUrl.pathname + currentUrl.search)
    //console.log(targetUrl.pathname + targetUrl.search)
    //console.log(current)
    return current
  }
</script>

{#if isCurrent()}
  <span {...props}><slot /></span>
{:else}
  <Link  href={href} {...props}><slot /></Link>
{/if}
